/* eslint quote-props: ["error", "as-needed"] */

import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Glyph from '../Glyph'
import Button from '@lmc/ui-kit/src/general/Button/Button'

const StyledGlyphWrapper = styled.span`
  display: inline-block;
  margin-top: -0.125em;
  vertical-align: middle;
  margin-right: ${(props) => (props.isLeft ? '0.5em' : '0')};
  margin-left: ${(props) => (props.isRight ? '0.5em' : '0')};
  ${(props) =>
    props.glyphStyle
      ? Object.entries(props.glyphStyle)
          .map(
            ([key, value]) =>
              `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`
          )
          .join(' ')
      : ''}
`

export function GlyphButton({
  children,
  glyph,
  glyphColor,
  glyphSize,
  glyphStyle,
  position,
  ...props
}) {
  const isDefault = position === 'default'
  const isLeft = position === 'left'
  const isRight = position === 'right'

  const icon = (
    <StyledGlyphWrapper
      isLeft={isLeft}
      isRight={isRight}
      glyphStyle={glyphStyle}
    >
      <Glyph color={glyphColor} name={glyph} size={glyphSize} />
    </StyledGlyphWrapper>
  )

  return (
    <Button {...props} variant="text">
      {(isDefault || isLeft) && icon}
      {children}
      {isRight && icon}
    </Button>
  )
}

GlyphButton.propTypes = {
  glyph: PropTypes.string,
  glyphColor: PropTypes.string,
  glyphSize: PropTypes.string,
  glyphStyle: PropTypes.object,
  position: PropTypes.oneOf(['default', 'left', 'right'])
}
GlyphButton.defaultProps = {
  glyphStyle: {},
  position: 'default'
}

export default GlyphButton
